var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-text"},[_vm._v("LOADING")]),_c('div',{staticClass:"loading-content"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }